import React, { useState } from "react";
import { assetIds, ThemedAsset } from "nemuru-components";
import { Box, Typography, useTheme } from "@material-ui/core";
import Text from "../../../../shared/components/Text";
import MainButton from "../../../../shared/components/MainButton";
import IconTitle from "../../../../shared/components/IconTitle";
import { Controller, useForm } from "react-hook-form";
import { ICON_TITLE_HEIGHT } from "../../../../../config/config";
import { StyledToggleButtonGroup } from "../../../../shared/components/StyledToggleButtonGroup";
import { PaymentMode } from "@nemuru-eng/js-api-client";

export const PaymentModeSelection = ({ onSubmitForm, data }) => {
  const { palette } = useTheme();
  const { control, getValues, handleSubmit } = useForm({
    defaultValues: {
      paymentMode: data?.paymentMode ?? PaymentMode.END_OF_MONTH,
    },
  });

  const paymentModeSelectorValues = [
    {
      value: PaymentMode.FIXED_INSTALLMENT,
      textId: "FIXED_INSTALMENT",
    },
    {
      value: PaymentMode.END_OF_MONTH,
      textId: "END_OF_MONTH",
    },
  ];

  const [selected, setSelected] = useState(
    data?.paymentMode ?? PaymentMode.END_OF_MONTH
  );

  return (
    <>
      <Box>
        <IconTitle
          icon={
            <ThemedAsset
              id={assetIds.ICON_MONEY}
              width={ICON_TITLE_HEIGHT}
              height={ICON_TITLE_HEIGHT}
              style={{ color: palette.secondary.main }}
            />
          }
          title={<Text tId="SELECT_PAYMENT_MODE" />}
          subtitle={<Text tId="SELECT_PAYMENT_MODE_SUBTITLE" />}
        />
        <Controller
          name="paymentMode"
          control={control}
          render={(props) => (
            <StyledToggleButtonGroup
              selection={selected}
              handleSelection={(e, value) => {
                if (value !== null) {
                  setSelected(value);
                  props.onChange(value);
                }
              }}
              options={paymentModeSelectorValues}
            />
          )}
        />
        <Box my={2}>
          <Typography variant="body2" color="textSecondary">
            {selected === PaymentMode.FIXED_INSTALLMENT && (
              <Text tId="FIXED_INSTALMENT_DESCRIPTION" />
            )}
            {selected === PaymentMode.END_OF_MONTH && (
              <Text tId="END_OF_MONTH_DESCRIPTION" />
            )}
          </Typography>
        </Box>
      </Box>
      <Box>
        <Typography variant="caption" color="textSecondary">
          * <Text tId={"CARD_SHIPPING_DESCRIPTION"} />
        </Typography>
        <MainButton onClick={handleSubmit(() => onSubmitForm(getValues()))} />
      </Box>
    </>
  );
};
